import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import type {CSSProperties} from 'react';

const Callback: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const code = searchParams.get('code');
        const error = searchParams.get('error');
        const errorDescription = searchParams.get('error_description');

        console.log('Callback received:', {
            hasCode: !!code,
            error: error || 'none',
            errorDescription: errorDescription || 'none',
            fullUrl: window.location.href
        });

        if (error) {
            console.error('Auth0 Error:', error, errorDescription);

            // Handle specific errors
            if (error === 'invalid_request' && errorDescription?.includes('connection is not enabled')) {
                console.error('WebAuthn/Passkey connection is not enabled');
                // Redirect back to signin-confirmation with error
                setTimeout(() => {
                    navigate('/signin-confirmation?error=passkey_not_available');
                }, 3000);
                return;
            }

            // Other errors - redirect to home
            setTimeout(() => {
                navigate('/?error=' + error);
            }, 3000);
            return;
        }

        if (code) {
            console.log('Authorization code received, Auth0 Action will handle the rest...');
        } else {
            console.warn('No authorization code found in callback');
        }
    }, [searchParams, navigate]);

    const containerStyle: CSSProperties = {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8f9fa',
        fontFamily: 'Arial, sans-serif'
    };

    const cardStyle: CSSProperties = {
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        maxWidth: '400px',
        width: '90%'
    };

    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (error) {
        return (
            <div style={containerStyle}>
                <div style={cardStyle}>
                    <h2 style={{ color: '#dc3545' }}>Authentication Error</h2>

                    {error === 'invalid_request' && errorDescription?.includes('connection is not enabled') ? (
                        <div>
                            <p>Passkey authentication is not yet available.</p>
                            <p style={{ fontSize: '14px', color: '#666' }}>
                                The passkey feature is being set up. Please use regular login for now.
                            </p>
                        </div>
                    ) : (
                        <div>
                            <p>There was an error with authentication:</p>
                            <p style={{ fontSize: '14px', color: '#dc3545' }}>
                                {error}: {errorDescription}
                            </p>
                        </div>
                    )}

                    <p style={{ fontSize: '14px', marginTop: '20px' }}>
                        Redirecting you back...
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div style={containerStyle}>
            <div style={cardStyle}>
                <div style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #007bff',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 20px'
                }} />
                <h2>Processing Authentication...</h2>
                <p>Please wait while we complete your sign-in.</p>
            </div>
            <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
        </div>
    );
};

export default Callback;